import { useState } from "react";
import Button from "@/components/button";
import Icon from "@/components/icon";
import EducatorsPublishButton from "@/features/educators/components/educators-publish-button";
import EducatorsSupportDrawer from "@/features/educators/components/educators-support-drawer";

const EDUCATOR_VIDEO_COVER_URL = '/educator-assets/video-cover.webp';
const EDUCATOR_VIDEO_URL = '/educator-assets/video.mp4';

function EducatorsVideo() {
  if (EDUCATOR_VIDEO_URL) {
    return (
      <video
        className="aspect-video w-full rounded-2xl object-cover"
        controls
        playsInline
        preload="metadata"
        aria-label="ویدیوی معرفی فروش دوره در آموزیم"
        poster={EDUCATOR_VIDEO_COVER_URL}
        src={EDUCATOR_VIDEO_URL}
      />
    );
  }

  return (
    <div
      role="img"
      aria-label="ویدیوی معرفی فروش دوره در آموزیم"
      className="relative flex aspect-video w-full items-center justify-center overflow-hidden rounded-2xl"
    >
      <div className="relative flex flex-col items-center text-white/40">
        <span className="text-4xl font-black tracking-tight">آموزیم</span>
        <span className="mt-1 text-[10px]">مرجع آموزش‌های ایتا</span>
      </div>
      <span className="absolute flex size-14 items-center justify-center rounded-full bg-white shadow-lg">
        <Icon name="play-fill" size={26} />
      </span>
    </div>
  );
}

export default function EducatorsInfoSection() {
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <section className="p-4 flex flex-col gap-4 text-center mb-10">
      <EducatorsVideo />

      <div className="mt-4">
        <h2 className="text-xl font-extrabold leading-8 text-foreground">
          شروع فروش دوره به صورت قسطی در
          <br />
          <span className="text-primary">آموزیم</span>
        </h2>

        <p className="mt-5 text-sm font-medium leading-7 text-foreground">
          پرداخت اقساطی، راهکاری موثر برای جذب مشتریان جدید و ابزاری
          <br />
          برای رشد پایدار فروشگاه شما
        </p>

        <div className="mt-5 flex flex-col gap-2">
          <EducatorsPublishButton
            className="h-12 w-full rounded-full bg-primary px-5"
            iconSize={22}
          />

          <Button
            type="button"
            size="lg"
            className="h-12 w-full rounded-full bg-[#0d152a] px-5 text-white hover:bg-[#17213b]"
            onClick={() => setSupportOpen(true)}
          >
            ارتباط با پشتیبانی
          </Button>
        </div>
      </div>

      <EducatorsSupportDrawer
        open={supportOpen}
        onOpenChange={setSupportOpen}
      />
    </section>
  );
}

